import { jsx as a, jsxs as n } from "react/jsx-runtime";
import { useContext as i } from "react";
import r from "classnames";
import { ThemeContext as m } from "../ThemeContext/index.js";
const h = "forma-ui__table__root", b = "forma-ui__table__table", f = "forma-ui__table__fixed", u = "forma-ui__table__head", x = "forma-ui__table__headCell", N = "forma-ui__table__row", p = "forma-ui__table__active", T = "forma-ui__table__selected", v = "forma-ui__table__cell", C = "forma-ui__table__columnTitle", l = {
  root: h,
  table: b,
  fixed: f,
  head: u,
  headCell: x,
  row: N,
  active: p,
  selected: T,
  cell: v,
  columnTitle: C
}, g = ({ id: t, className: o, isActive: c, isSelected: s, children: e }) => /* @__PURE__ */ a("tr", { id: t, className: r(l.row, o, c && l.active, s && l.selected), children: e }), k = ({ className: t, title: o, children: c, colSpan: s, rowSpan: e, onClick: _ }) => {
  const { viewport: d } = i(m);
  return /* @__PURE__ */ n("td", { className: r(l.cell, t), onClick: _, colSpan: s, rowSpan: e, children: [
    d === "phone" && o && /* @__PURE__ */ a("div", { className: l.columnTitle, children: o }),
    c
  ] });
}, q = ({ columns: t, className: o, children: c, fixed: s }) => /* @__PURE__ */ a("div", { className: r(l.root, o), children: /* @__PURE__ */ n("table", { className: r(l.table, s && l.fixed), children: [
  t && /* @__PURE__ */ a("thead", { children: /* @__PURE__ */ a("tr", { className: l.head, children: t.map(
    (e, _) => /* @__PURE__ */ a("th", { className: r(l.headCell, e == null ? void 0 : e.className), style: e.style, children: e == null ? void 0 : e.children }, _)
  ) }) }),
  /* @__PURE__ */ a("tbody", { children: c })
] }) });
export {
  q as Table,
  k as TableCell,
  g as TableRow
};
